import ajax from '../utils/ajax'
function login(name,pwd) {
    return ajax.post('/api/login/auth',{
        name, pwd
    }).then(resp=>{
        if(resp.status&&resp.status==='success'){
            localStorage.setItem('userInfo', JSON.stringify(resp.result.user));
            return resp.result.user;
        }else{
            throw new Error(resp.message);
        }
    })
}

function regist(name,pwd) {
    return ajax.post('/api/login/reg',{
        name, pwd, type:1
    }).then(resp=>{
        if(resp.status&&resp.status==='success'){
            return resp.result;
        }else{
            throw new Error(resp.message);
        }
    })
}

function logout() {
    return new Promise((r,rj)=>{
        let cname = 'JSESSIONID';
        let cvalue = '';
        let expires = 'expires='+new Date(0).toUTCString;
        document.cookie = `${cname}=${cvalue};${expires}`;
        r();
    })
}

function getLoginInfo() {
    return ajax.get('/api/project/-1').then((resp)=>{
        if(resp.status==='success'){
            let userInfo;
            try {
                userInfo = JSON.parse(localStorage.getItem('userInfo'));
                if(!userInfo){
                    throw new Error();
                }
            } catch (error) {
                throw new Error('无法获取用户信息，需要重新登录')
            }
            return userInfo;
        }else{
            throw new Error('未登录')
        }
    })
}

export {login, logout, getLoginInfo, regist};